<template>
  <div class="row">
    <div class="col">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div class="flex items-center justify-between items-center">
          <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
            Manage all notifications on the system
          </p>
          <div
            class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
          >
            <button
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
              @click="openFilter"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button
              v-if="isSelectAll"
              class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
              @click="deSelectAll"
            >
              Unselect All
            </button>
            <button
              v-else
              class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
              @click="selectAll"
            >
              Select All
            </button>
            <button
              id="markAsRead"
              @click="markAsRead"
              :disabled="selectedIds < 1"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
            >
              Mark As Read
            </button>
          </div>
        </div>
        <div class="flex flex-col items-center mt-[16px]">
          <div v-if="loading">
            <div colspan="12" class="text-center">
              <div
                class="text-center"
                style="padding-top: 100px; padding-bottom: 50px"
              >
                <span
                  class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                  style="font-size: 8rem"
                ></span>
                <h3
                  class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px"
                >
                  Please wait while we load the notification's list
                </h3>
              </div>
            </div>
          </div>
          <div class="w-full" v-else>
            <NotificationCard
              v-for="n in altNotifications"
              :key="n.id"
              :notification="n"
              @onDeleteComplete="getNotifications"
              @onCardClicked="submitRead"
              @checkMessage="selectMessage"
            />
          </div>
        </div>
        <div class="">
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="pageNumber"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Read Status:
              </label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select notification type"
                  v-model="filter.status"
                >
                  <option value="true">Read</option>
                  <option value="false">Unread</option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Type:
              </label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select notification type"
                  v-model="filter.type"
                >
                  <option
                    v-for="item of notificationTypes"
                    :key="item"
                    :value="item"
                    >{{ item }}</option
                  >
                </select>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Start Date:</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="date"
                  placeholder="Select a date"
                  v-model="filter.startDate"
                />
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >End Date:</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="date"
                  placeholder="Select a date"
                  v-model="filter.endDate"
                />
              </div>
            </div>
          </div>

          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              @click="resetFilter"
            >
              Reset
            </button>

            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              :disabled="isBusy"
              @click="getNotifications"
            >
              <span v-if="!isBusy">Filter</span>
              <span v-else>Busy...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import NotificationCard from "../components/NotificationCard.vue";
import Pagination from "../components/Pagination.vue";

export default {
  components: { NotificationCard, Pagination },

  data() {
    return {
      search: "",
      isBusy: false,
      notifications: [],
      filteredNotifications: [],
      altNotifications: [],
      notificationTypes: [],
      isSelectAll: false,
      selectedIds: [],
      filter: {
        status: "",
        type: "",
        startDate: "",
        endDate: "",
      },
      status: "",
      pageSize: 10,
      pageNumber: 0,
      count: 0,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      loading: false,
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  mounted() {
    this.getNotifications();
    this.getNotificationTypes();
  },

  methods: {
    async getNotifications() {
      this.loading = true;
      this.altNotifications = [];
      this.selectedIds = [];
      try {
        this.isBusy = true;
        const response = await this.$http.get(
          `/Notification?type=${this.filter.type}&Read=${this.filter.status}&StartDate=${this.filter.startDate}&EndDate=${this.filter.endDate}&PageNumber=${this.pageNumber}&PageSize=${this.pageSize}`
        );

        if (response.ok) {
          this.filteredNotifications = this.notifications = response.body.data;
          this.formatNotificationArray(response.body.data);
          this.pageNumber = response.body.pageNumber;
          this.pageSize = response.body.pageSize;
          this.count = response.body.count;
          this.pageCount = Math.ceil(
            response.body.count / response.body.pageSize
          );
          this.hasPrev = response.body.hasPrev;
          this.hasNext = response.body.hasNext;
        }

        this.isBusy = false;
        this.loading = false;

        this.closeFilter();
      } catch (error) {
        this.isBusy = false;
        this.loading = false;
      }
    },

    async getNotificationTypes() {
      try {
        this.isBusy = true;
        const response = await this.$http.get(`/Notification/types`);
        if (response.ok) {
          this.notificationTypes = response.body;
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      }
    },

    async submitRead(id) {
      let body = {
        ids: [id].toString(),
      };
      const response = await this.$http.put("/notification/read", body);
      if (response.body) {
        this.getNotifications();
        this.getUnreadCount();
      }
    },

    async getUnreadCount() {
      const response = await this.$http.get("/Notification/count?isRead=false");
      this.$store.commit("setNotificationCount", response.body);
    },

    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },

    prev() {
      this.pageNumber -= 1;
      this.getNotifications();
    },
    next() {
      this.pageNumber += 1;
      this.getNotifications();
    },

    gotoPage(pageNumber) {
      this.pageNumber = pageNumber;
      this.getNotifications();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getNotifications();
    },

    selectMessage(id) {
      if (this.selectedIds.includes(id)) {
        let filterSelected = this.selectedIds.filter((item) => item != id);
        this.selectedIds = filterSelected;
      } else {
        this.selectedIds.push(id);
      }
    },

    async markAsRead() {
      this.isBusy = true;
      let body = {
        ids: this.selectedIds.toString(),
      };
      if (this.selectedIds.length < 1) {
        return this.$toast.warning("You must select notification.", {
          icon: true,
          rtl: false,
        });
      }
      await this.$http
        .put("/notification/read", body)
        .then(function(res) {
          this.altNotifications = [];
          this.isSelectAll = false;
          this.getNotifications();
          this.getUnreadCount();
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    formatNotificationArray(arr) {
      for (var i = 0; i < arr.length; i++) {
        let obj = {
          isChecked: false,
          id: arr[i].id,
          isRead: arr[i].isRead,
          date: arr[i].date,
          title: arr[i].title,
          statement: arr[i].statement,
          focalPoint: arr[i].focalPoint,
          secondary: arr[i].secondary,
          ctaStatus: arr[i].ctaStatus,
          ctaLabel: arr[i].ctaLabel,
          url: arr[i].url,
          recipientId: arr[i].recipientId,
        };
        this.altNotifications.push(obj);
      }
    },

    selectAll() {
      for (var i = 0; i < this.altNotifications.length; i++) {
        this.altNotifications[i].isChecked = true;
        this.selectedIds.push(this.altNotifications[i].id);
      }
      this.isSelectAll = true;
    },

    deSelectAll() {
      for (var i = 0; i < this.altNotifications.length; i++) {
        this.altNotifications[i].isChecked = false;
      }
      this.isSelectAll = false;
      this.selectedIds = [];
    },

    openFilter() {
      $("#mod-filter").modal("show");
    },

    closeFilter() {
      $("#mod-filter").modal("hide");
    },

    resetFilter() {
      this.filter = {
        status: "",
        type: "",
        startDate: "",
        endDate: "",
      };
      this.getNotifications();
    },
  },
};
</script>

<style>
.card-body {
  margin-top: 20px;
  background-color: #f8f8f8;
}
</style>
